import React from "react";
import Modal from '@mui/joy/Modal';
import ModalClose from '@mui/joy/ModalClose';
import ModalDialog from '@mui/joy/ModalDialog';
import DialogTitle from '@mui/joy/DialogTitle';
import DialogContent from '@mui/joy/DialogContent';
import DialogActions from '@mui/joy/DialogActions';
import Divider from '@mui/joy/Divider';
import moment from 'moment';


function ModalFCILogs( {handleOpen, isOpen, arrayLogs, fundId}) {
    
    return (
        <Modal
            aria-labelledby="close-modal-title"
            open={isOpen}
            onClose={() => handleOpen(false) }
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <ModalDialog>
                <ModalClose variant="outlined" />
                <DialogTitle>  Logs de Envios: #{fundId}</DialogTitle>
                <Divider />
                <DialogContent>
                    <table className="table table-striped table-hover" >
                        <thead style={{backgroundColor: '#FFFFFF'}}>
                            <tr className="text-nowrap">
                                <th>Fecha</th>
                                <th>Descripción</th>
                                <th>Mails</th>
                            </tr>
                        </thead>
                        <tbody className="table-border-bottom-0">
                            {arrayLogs.map(log => {
                                return (
                                    <tr key={log.id} className="small">  
                                        <td>{moment(log.date).format('DD/MM/YYYY HH:mm')}</td>
                                        <td>
                                            {log.description === 'sent' && 'ENVIADO'}
                                            {log.description === 'resent' && 'REENVIADO'}
                                            {log.description === 'rejected' && 'RECHAZADO'}
                                            {log.description === 'sent_to_management_company' && 'ENVIADO A SOCIEDAD GERENTE'}
                                            {log.description === 'pending_management_company' && 'PENDIENTE DE APROBACIÓN POR SOCIEDAD GERENTE'}
                                        </td>
                                        <td>{log.emails}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <button type="button" className="btn btn-outline-secondary"  onClick={() => handleOpen(false)}> Cerrar </button>                    
                </DialogActions>
            </ModalDialog>
        </Modal>

    );
}

export default ModalFCILogs;